<template>
    <div>

        <input :type="fieldType"
            :id="fieldId"
            :name="fieldName"
            :value="value"
            :class="fieldClass"
            :placeholder="placeholderText"
            @blur="onBlur"
            @focus="focussed"
            @keyup="keyUp($event, true)"
            @change="keyUp"
            :disabled="disabled"
            v-mask="mask"
            ></input>

        <ul v-show="suggestions.length" class="autosuggest-list">
            <li v-for="(item, index) in suggestions" :key="index" @click="suggestionSelected(item)">{{ item }}</li>
        </ul>
    </div>
</template>

<script>


import Vue from 'vue'
import field from '@/mixins/field';
import CONF from '@/config';
const VueInputMask = require('vue-inputmask').default
Vue.use(VueInputMask)

export default {
    data() {
        return {
            suggestions: [],
            options: this.data.options,
            delayTimer: {},
            test: ''
        }
    },
    computed: {
        mask() {
            //https://github.com/scleriot/vue-inputmask
            var mask = '';
            switch (this.data.mask) {
                case '#':
                    mask = {
                        regex: '[0-9]*[\.]?[0-9]{0,2}',
                        autoUnmask: true
                    }
                    break;
                case "$":
                    mask = {
                        regex: '\$ [0-9]*[\.]?[0-9]{0,2}',
                        autoUnmask: true
                    }
                    break;
                case "%":
                    mask = {
                        regex: '\% [0-9]*[\.]?[0-9]{0,2}',
                        autoUnmask: true
                    }
                    break;
                case 'tel':
                    mask = {
                        mask: '(999) 999-9999',
                        autoUnmask: true
                    }
                    break;
                case 'sin':
                  mask = {
                    mask: '999-999-999',
                    autoUnmask: true
                  }
                  break;
                case 'dl':
                  mask = {
                    mask: 'A9999-99999-99999',
                    autoUnmask: true
                  }
                  break;
                case 'email':
                    mask = {
                        mask: "*{1,20}[.*{1,20}][.*{1,20}][.*{1,20}]@*{1,20}[.*{2,6}][.*{1,2}]",
                        autoUnmask: false,
                        greedy: false,
                        definitions: {
                            '*': {
                                validator: "[0-9A-Za-z!#$%&'*+/=?^_`{|}~\-]",
                                casing: "lower"
                            }
                        }
                    }
                    break;
              case 'card':
                mask = {
                  mask: '####-####-####-####',
                  autoUnmask: true
                }
                break;
              case 'card_expire_date':
                mask = {
                  mask: '##/##',
                  autoUnmask: true,
                  placeholder: 'MM/YY'
                }
                break;
                case 'none':
                    mask: ''
                    break;
            }

            return mask;

        }
    },
    mixins: [field],
    methods: {
        suggestionSelected(val) {
            this.suggestions = [];
            this.$emit('input', val)
        },
        focussed() {
            this.$emit('focus',this.fieldName)
        },
        onBlur() {
            //delay for suggestionSelected to work
            setTimeout(() => this.suggestions = [], 100);
            this.$emit('blur',this.fieldName)
        },
        emitColor(obj) {
            this.$emit('input',obj.hex8)
        },
        keyUp(ev, key = false) {
            var val = ev.target.value;
            this.$emit('input', val)
            this.$emit('keyup', this.data.name)
            if (key && this.data.type == 'autosuggest') {
                var self = this;
                var params = new URLSearchParams();
                params.append('search', val);

                clearTimeout(this.delayTimer);

                this.delayTimer = setTimeout(function () {
                    if (self.data.ajax) {
                        self.$http.get(CONF.API_URL + self.data.ajax, {params: params})
                                .then(function (res) {
                                    self.suggestions = res.data
                                    if (self.value != ev.target.value)
                                        self.$emit('input', ev.target.value)
                                })
                    } else {
                        self.suggestions = self.options.find(function (item) {
                            return item.search(val);
                        });
                    }
                }, 300);
            }
        }
    }
}
</script>
<style lang="scss">
.autosuggest-list {
  border: 1px solid var(--primary);
  border-radius: 3px;
  margin-top: 2px;
  position: absolute;
  width: 100%;
  z-index: 999;
  background: #fff;
  li {
    width: 100%;
    border-bottom: 1px solid var(--primary);
    cursor: pointer;
    padding: 7px;
    &:last-child {
      border-bottom: none;
    }
    &:hover {
      background: var(--primary);
      color: #fff;
    }
  }
}
</style>